import React from "react";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { ArrowForward, Lock } from "@material-ui/icons";
import { CustomColumnModalLockedHeader } from "./modules/CustomColumnModalLockedHeader";
import { openPricingPage } from "utils/Utils";
import { useCustomColumnLockedModal } from "./utils/useCustomColumnLockedModal";

export const CustomColumnLockedModal = () => {
  const { isCustomColumnLockedModalOpen } = useCustomColumnLockedModal();
  return (
    <ExlyModal
      open={isCustomColumnLockedModalOpen}
      customHeader={<CustomColumnModalLockedHeader />}
      onPrimaryBtnClick={openPricingPage}
      primaryBtnText="See Plans"
      primaryBtnFullWidth
      showSecondaryBtn={false}
      primaryBtnProps={{
        endIcon: <ArrowForward />,
      }}
      secondaryBtn={false}
      modal_props={{
        modalPaperClassName: "tw-w-[438px]",
      }}
    >
      <div className="tw-flex tw-items-center tw-py-4 tw-flex-col">
        <Lock className="!tw-fill-[#ffaa00] !tw-w-[54px] !tw-h-[54px]" />
        <div className="tw-text-[#272522] tw-text-center tw-text-[16px] tw-font-normal tw-font-medium tw-leading-normal tw-mt-4">
          This is a premium exclusive feature
        </div>
        <div className="tw-mt-2.5 tw-text-[#272522] tw-text-center tw-text-[14px] tw-font-normal tw-font-light tw-leading-normal tw-opacity-50">
          Upgrade your plan to create custom columns.
        </div>
      </div>
    </ExlyModal>
  );
};
